import Ajax from '../util/ajax';
export function actionOnOff(id, value) {
    return (dispatch) => {
        const a = new Ajax(dispatch, true);
        a.post('/action/' + id + '/exec', value);
    };
}
